<template>
    <div>
        <v-card>
            <v-card-text>
                <v-list>
                    <v-list-item
                        :key="indexModule"
                        v-for="(module, indexModule) in module.filter(each => each.authorization == true)"
                        :to="module.to"
                        dense
                        link>
                        <v-list-item-icon class="ml-5">
                            <v-icon>{{ module.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ module.text }}</v-list-item-title>
                    </v-list-item>
                </v-list>   
            </v-card-text>    
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "ModuleDialog",
    components: {
        
    },
    data() {
        return {
            display: false,
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        ...mapState('authentication', ["modules"]),
        module(){
            return [
                { 
                    text: this.$t('sales_and_distribution'),
                    icon: "mdi-order-bool-descending",
                    to: "/sales",
                    authorization: this.modules ? this.modules.sales ? true : false : false
                },
                { 
                    text: this.$t("inventory_management"),
                    icon: "mdi-warehouse",
                    to: "/warehouse-select",
                    authorization: this.modules ? this.modules.warehouse ? true : false : false
                },
                {
                    text: this.$t("supply_chain"),
                    icon: "mdi-card-text",
                    to: "/purchase",
                    authorization: this.modules ? this.modules.purchase ? true : false : false
                },
                {
                    text: this.$t('financial_accounting'),
                    icon: "mdi-bank",
                    to: "/accounting",
                    authorization: this.modules ? this.modules.accounting ? true : false : false
                },
                {
                    text: this.$t("fleet_management"),
                    icon: "mdi-truck-cargo-container",
                    to: "/fleet",
                    authorization: this.modules ? this.modules.fleet ? true : false : false
                },
                {
                    text: this.$t('administration'),
                    icon: "mdi-cog",
                    to: "/administration",
                    authorization: this.modules ? this.modules.administration ? true : false : false
                },
            ]  
        } 
    },
    methods: {
    },
}
</script>